//element-ui国际化
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
//配置文件，导入所有的中英文配置
import wrong from "./wrong/wrong.json";
import supervise from "./supervise/supervise.json";
import studentItem from "./studentList/studentItem/studentItem.json";
import list from "./studentList/list/list.json"
import leftStudentItem from "./studentList/leftStudentItem/leftStudentItem.json";
import index from "./studentList/index/index.json";
import card from "./studentList/card/card.json";
import allStudent from "./studentList/allStudent/allStudent.json";
import current from "./studentDetail/current/current.json";
import history from "./studentDetail/history/history.json";
import info from "./studentDetail/info/info.json";
import subjective from "./studentDetail/subjective/subjective.json";
import studentDetail from "./studentDetail/studentDetail.json";
import questionDetail from "./questionDetail/questionDetail.json";
import components from "./components/components.json";

import navbar from "./layout/navbar/navbar.json";

export default {
    en: {
      ...elementEnLocale,
		  ...wrong.en,
		  ...supervise.en,
		  ...studentItem.en,
		  ...list.en,
		  ...leftStudentItem.en,
		  ...index.en,
		  ...card.en,
		  ...allStudent.en,
		  ...current.en,
		  ...history.en,
		  ...info.en,
		  ...subjective.en,
      ...studentDetail.en,
			...navbar.en,
			...questionDetail.en,
			...components.en,
	},
	zh: {
      ...elementZhLocale,
		  ...wrong.zh,
		  ...supervise.zh,
		  ...studentItem.zh,
		  ...list.zh,
		  ...leftStudentItem.zh,
		  ...index.zh,
		  ...card.zh,
		  ...allStudent.zh,
		  ...current.zh,
		  ...history.zh,
		  ...info.zh,
		  ...subjective.zh,
      ...studentDetail.zh,
			...navbar.zh,
			...questionDetail.zh,
			...components.zh,
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js